import { render, staticRenderFns } from "./ex-details.vue?vue&type=template&id=c395e3de&scoped=true"
import script from "./ex-details.vue?vue&type=script&lang=js"
export * from "./ex-details.vue?vue&type=script&lang=js"
import style0 from "./ex-details.vue?vue&type=style&index=0&id=c395e3de&prod&scoped=true&lang=scss"
import style1 from "./ex-details.vue?vue&type=style&index=1&id=c395e3de&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@2.0.1_webpack@4.47.0__css-loader@1.0.1_webpack@4.47.0__ejs@2._efqjtiugzhgbjdza5v3l2szjuq/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c395e3de",
  null
  
)

export default component.exports